import { useMemo } from "react";
import { trpc } from "@/lib/trpc";

export type OwnedOrganization = {
  id: string;
  name: string;
  logoUrl: string | null;
};

/** Organizações onde o usuário logado é OWNER, separadas por área de atuação — base das visões
 *  agregadas da organização Pessoal (dashboard, agenda). */
export function useOwnedOrganizations() {
  const query = trpc.organization.listMine.useQuery();

  return useMemo(() => {
    const owned = (query.data ?? []).filter((m) => m.role === "OWNER" || m.role === "PARTNER");
    const clinics: OwnedOrganization[] = owned
      .filter((m) => m.organization.types.includes("DENTAL_OFFICE"))
      .map((m) => ({ id: m.organization.id, name: m.organization.name, logoUrl: m.organization.logoUrl }));
    const labs: OwnedOrganization[] = owned
      .filter((m) => m.organization.types.includes("DENTAL_LAB"))
      .map((m) => ({ id: m.organization.id, name: m.organization.name, logoUrl: m.organization.logoUrl }));
    return {
      isLoading: query.isLoading,
      clinics,
      labs,
      all: owned.map((m) => ({ id: m.organization.id, name: m.organization.name, logoUrl: m.organization.logoUrl })),
    };
  }, [query.data, query.isLoading]);
}
